<template>
    <div class="input-tag product-tag">
        <span v-for="(it, pos) in value" :key="it.id"
              :class="[
                  { error: errors[pos].length > 0 },
                  'option-' + it.id
              ]"
              class="item option">
            <span v-if="it.name" :title="it.name" class="title">{{ it.name }}</span>
            <span v-else class="title">{{ it }}</span>

            <IconClose v-if="canRemove" class="remove icon" @click="remove(pos)" />

            <TooltipOld v-if="errors[pos].length > 0"
                     :bindTo="'.input-tag .option' + '.option-' + it.id"
                     class="error"
                     trigger-on="hover"
            >
                <div v-for="e in getErrors(errors[pos])" :key="e" class="error">
                    {{ e }}
                </div>
            </TooltipOld>
        </span>

        <input ref="search"
               :placeholder="placeholder"
               :value="searchText"
               class="search"
               type="text"
               @input="onInput($event.target.value)"
               @keyup.enter="onAdd()"
               @keydown.delete.stop="onDelete()"
        />
    </div>
</template>

<script>
import IconClose from './icons/close.svg?component';

const aliasName = /^[\wА-Яа-яЁё\s]*$/;

export default {
    components: {
        IconClose,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        errors: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'Введите синоним и нажмите Enter',
        },
        inputValidator: {
            type: Function,
            default: (value) => aliasName.test(value),
        },
        canRemove: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            searchText: '',
        };
    },
    methods: {
        remove(id) {
            if (!this.canRemove)
                return;

            this.$emit('remove', id);
        },
        onAdd() {
            if (!this.searchText)
                return;

            let text = this.searchText.trim();
            if (!text)
                return;

            this.$emit('add', text);
            this.searchText = '';
        },
        onDelete() {
            const last = this.value.length - 1;
            if (!this.searchText && last >= 0) {
                this.remove(last);
            }
        },
        getErrors(errors) {
            return Array.from(new Set(errors));
        },
        onInput(value) {
            let text = this.searchText;

            if (this.inputValidator(value))
                text = value;

            this.searchText = text;
            this.$refs.search.value = text;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins';

.input-tag {
    height: 100%;
    width: 100%;

    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    min-height: 36px;

    background: var(--input-background);
    box-shadow: var(--input-shadow);
    border: var(--input-border);
    border-radius: var(--input-border-radius);
    padding: var(--input-padding);

    &:hover:not(:focus):not(.error):not([disabled]):not(.disabled) {
        border: var(--input-hover-border);
    }

    > .option {
        flex: none;
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
        background: rgba(16, 24, 40, 0.1);
        max-width: 100%;
        overflow: hidden;
        cursor: default;
        margin: 0;

        & > .title {
            flex: auto;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        & > .remove {
            @include icon(16px, 16px);
            opacity: 0.5;
        }

        &.error {
            background: rgba(255, 71, 71, 0.15);

            & > .title,
            & > .remove {
                color: #FF0C0C;
                opacity: 1;
            }
        }
    }

    input[type="text"].search {
        padding: 4px 8px;
        width: 60px;
        border: none;
        box-shadow: none;
        flex-grow: 2;

        &:hover:not(:focus):not(.error):not([disabled]):not(.disabled) {
            border: none;
        }
    }
}
</style>
